import { mainPath } from "../../lib/mainPath";
import { requestsTemplates } from "../../lib/requestsTemplates";

export const post = (limit) =>
  requestsTemplates.post(mainPath, "/vacation_limits",limit);